<template>
  <!-- v-if="!item.hidden && item.children && item.children.some(x => !x.hidden) && hasGroupRouters(item)" -->
  <div
    v-if="!item.hidden && item.children && item.children.some(x => !x.hidden)"
    class="menu-wrapper">
    <!-- eslint-disable-next-line -->
    <template v-if="transferChild && hasOneShowingChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
      <app-link :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{ 'submenu-title-noDropdown': !isNest }">
          <menu-item
            v-if="onlyOneChild.meta"
            :icon="onlyOneChild.meta.icon || item.meta.icon"
            :title="onlyOneChild.meta.title" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else :index="resolvePath(item.path)" popper-class="popper-class">
      <template slot="title">
        <menu-item v-if="item.meta" :icon="item.meta.icon" :title="item.meta.title" />
      </template>

      <template v-for="child in item.children">
        <!-- TODO: groups -->
        <!-- <template v-if="!child.hidden && hasGroupRouters(item, child)"> -->
        <template v-if="!child.hidden">
          <side-bar-item
            v-if="child.children && child.children.length > 0"
            :key="child.path"
            :is-nest="true"
            :item="child"
            :base-path="resolvePath(child.path)"
            class="nest-menu" />
          <app-link v-else :key="child.name" :to="resolvePath(child.path)">
            <el-menu-item :index="resolvePath(child.path)">
              <menu-item v-if="child.meta" :icon="child.meta.icon" :title="child.meta.title" />
            </el-menu-item>
          </app-link>
        </template>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import path from 'path';
import { isExternal } from '@/utils';
import MenuItem from './menu-item.vue';
import AppLink from './app-link.vue';

export default {
  name: 'SideBarItem',
  components: { MenuItem, AppLink },
  props: {
    // route object
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      onlyOneChild: null,
      transferChild: true, // 只有1个子菜单时是否升级升主菜单显示
    };
  },
  computed: {
    // ...mapGetters(['groups']),
    // hasGroupRouters() {
    //   return (item, child) => {
    //     if (this.groups.length < 1) {
    //       return true;
    //     }
    //     if (child) {
    //       // console.log(`${item.path}/${child.path}`);
    //       return this.groups.some(g => g.test(`${item.path}/${child.path}`));
    //     }
    //     return this.groups.some(g => item.children.some(c => g.test(`${item.path}/${c.path}`)));
    //   };
    // },
  },
  methods: {
    hasOneShowingChild(children, parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false;
        }
        // Temp set(will be used if only has one showing child)
        this.onlyOneChild = item;
        // this.onlyOneChild.path = `/x/${this.onlyOneChild.path}`;
        return true;
      });
      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }
      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true };
        return true;
      }
      return false;
    },
    resolvePath(routePath) {
      if (this.isExternalLink(routePath)) {
        return routePath;
      }
      return path.resolve(this.basePath, routePath);
    },
    isExternalLink(routePath) {
      return isExternal(routePath);
    },
  },
};
</script>
